<!-- 爱心捐赠 -->
<template>
  <div class="pageView">
    <PCNavbar />
    <CarouselHome type="donate" />
    <div class="main-wrap">
      <div class="block-wrap">
        <div class="tab">
          <div class="tab-item" :class="{ current: current == 1 }" @click="toggle(1)">捐赠方式</div>
          <div class="tab-item" :class="{ current: current == 2 }" @click="toggle(2)">捐赠记录</div>
          <div class="tab-item" :class="{ current: current == 3 }" @click="toggle(3)">票据申领</div>
          <div class="tab-item" :class="{ current: current == 4 }" @click="toggle(4)">证书申领</div>
          <div class="tab-item" :class="{ current: current == 5 }" @click="toggle(5)">抵扣说明</div>
          <div class="tab-item" :class="{ current: current == 6 }" @click="toggle(6)" v-if="aixin_status == 1">爱心传递</div>
        </div>
        <div class="article cifu-content" v-if="current == 1">
          <h3 class="h3">银行捐赠</h3>
          <div class="info">
            <div class="msg" v-for="(item, index) in config.yhjz" :key="index">
              <div class="left">
                <div class="title" style="margin-top: 20px;">捐赠信息</div>
                <div class="num">{{ index + 1 }}</div>
              </div>
              <div class="right">
                <div class="row">
                  <div class="label">开户名</div>
                  <div class="text">{{ item.value1 }}</div>
                </div>
                <div class="row">
                  <div class="label">账号</div>
                  <div class="text">{{ item.value2 }}</div>
                </div>
                <div class="row">
                  <div class="label">开户行</div>
                  <div class="text">{{ item.value3 }}</div>
                </div>
              </div>
            </div>
          </div>
          <p class="p">捐赠须知</p>
          <p class="p">{{ config.yhjzxz }}</p>
          <h3 class="h3">在线捐赠</h3>
          <div class="box">
            <div class="box-item" v-for="(item, index) in list" :key="index" @click="handleToProjectDetail(item.id)">
              <div class="box-inner">
                <img src="@/assets/images/itemJ.png" alt="">
                <div class="fontStyle">{{ item.title }}</div>
              </div>
            </div>
            <!-- <div v-for="(item, index) in 3 - listrow" :key="index" class="box-item1">
              <div v-if="listrow > 0" style="opacity: 0;">
                <div class="box-inner">慈福助力圆梦大学次捐{{item}}</div>
              </div>
            </div> -->
          </div>
          <p class="p">捐赠须知</p>
          <p class="p">{{ config.zxjzxz }}</p>
          <h3 class="h3">公开募捐平台</h3>
          <div class="jigou" v-for="(item, index) in list2" :key="index">
            <el-image class="img" src="item.image" />
            <h4 class="h4">{{ item.title }}</h4>
          </div>
          <div class="box">
            <p class="p">捐赠须知</p>
            <p class="p">{{ config.gkmjptxz }}</p>
          </div>
        </div>
        <div class="article cifu-content" v-if="current == 2" :style="{ paddingTop: platform == 'web' ? '50px' : '20px' }">
          <div class="search-block" v-if="isSearch">
            <div class="search-text">
              <i class="el-icon-search" style="font-weight: bold" />
              查询我的捐赠记录
            </div>
            <el-button class="search-btn" @click="queryMyData">查询我的捐赠</el-button>
          </div>
          <div class="table">
            <el-table
              :data="tableData"
              border
              header-row-class-name="table-header"
              :cell-style="{ fontSize: platform == 'web' ? '16px' : '12px', color: '#4F4F4F' }"
              style="width: 100%"
            >
              <el-table-column prop="pay_time_text" label="捐赠时间" align="center" />
              <el-table-column prop="name" label="捐赠人" align="center" />
              <el-table-column prop="project.title" label="捐赠项目" align="center" />
              <el-table-column prop="price" label="捐赠金额" align="center" />
              <el-table-column prop="pay_type" label="支付方式" align="center" />
              <el-table-column prop="platform" label="捐赠平台" align="center" />
            </el-table>
          </div>
        </div>
        <div class="article pt38" v-if="current == 3">
          <h3 class="h3">票据申领须知</h3>
          <div class="box">
            <div class="p" v-html="config.pjslxz" style="width: 100%;"></div>
          </div>
          <div class="tabs">
            <div class="tabs-item" :class="{ current: active == 1 }" @click="tabs(1)">单笔申请</div>
            <div class="tabs-item" :class="{ current: active == 2 }" @click="tabs(2)">批量申请</div>
          </div>
          <el-form ref="formRef" class="form" :model="form" :rules="rules" label-width="auto" label-position="top" hide-required-asterisk>
            <el-form-item prop="name">
              <el-input v-model="form.name" placeholder="请输入申领人姓名" />
            </el-form-item>
            <el-form-item label="交易单号查询" prop="flow_number" v-if="active == 1">
              <el-input v-model="form.flow_number" placeholder="请输入交易单号" />
            </el-form-item>
            <el-form-item prop="excel_url" v-if="active == 2">
              <el-input v-model="form.excel_url" clearable readonly>
                <template slot="append">
                  <el-upload
                    v-model="fileList"
                    class="upload-demo"
                    :action="uploadUrl"
                    :limit="1"
                    :show-file-list="false"
                    :headers="{ token }"
                    :before-upload="beforeUpload"
                    :on-success="handleSuccess"
                  >
                    <el-button class="btn">点击选择</el-button>
                  </el-upload>
                </template>
              </el-input>
            </el-form-item>
            <div v-if="active == 2">备注：请先下载模版，编辑后再上传文件</div>
            <el-form-item style="margin-top: 40px" v-if="status == 1">
              <div class="flex-start-center">
                <el-button class="btn" @click="handleQuery">查询</el-button>
                <!-- <el-button class="btn" v-if="active == 1 && status == 2" @click="handleApply">申领</el-button> -->
                <el-button class="btn downBtn" v-if="active == 2" @click="downloadTemplate" style="margin-left: 10px;">下载模板</el-button>
              </div>
            </el-form-item>
          </el-form>
          <div class="totalInfo" v-if="status == 2">
            <span class="ite">申请开票总数：{{ tableData.length }} 笔</span>
            <span class="ite">申请开票总额：￥ {{ totalAmount.toFixed(2) }} 元</span>
          </div>
          <el-table
            v-if="status == 2"
            :data="tableData"
            border
            stripe
            header-row-class-name="table-header"
            :cell-style="{ fontSize: platform == 'web' ? '18px' : '12px' }"
            style="width: 100%"
          >
            <el-table-column prop="pay_time_text" label="捐赠时间" align="center" />
            <el-table-column prop="price" label="捐赠金额（元）" align="center" />
            <el-table-column prop="project.title" label="项目名称" align="center" />
            <el-table-column prop="pay_type" label="支付方式" align="center" />
          </el-table>
          <div class="tabs" v-if="status == 2">
            <div class="tabs-item" :class="{ current: select == 1 }" @click="choose(1)">个人</div>
            <div class="tabs-item" :class="{ current: select == 2 }" @click="choose(2)">企业</div>
            <div class="tabs-item" :class="{ current: select == 3 }" @click="choose(3)">匿名</div>
          </div>
          <el-form
            v-if="status == 2"
            class="form"
            ref="formDataRef"
            :model="formData"
            :rules="formDataRules"
            label-position="top"
            :inline="platform == 'web'"
            style="width: 100%"
          >
            <el-form-item label="姓名" prop="name" :style="{ width: platform == 'web' ? '45%' : '100%' }" v-if="select !== 2">
              <el-input v-model="formData.name" placeholder="请输入姓名" style="width: 90%" />
            </el-form-item>
            <el-form-item label="身份证号" prop="zhengjian_number" :style="{ width: platform == 'web' ? '45%' : '100%' }" v-if="select !== 2">
              <el-input v-model="formData.zhengjian_number" maxlength="18" placeholder="请输入身份证号" style="width: 90%" />
            </el-form-item>
            <el-form-item label="单位名称" prop="name" :style="{ width: platform == 'web' ? '45%' : '100%' }" v-if="select == 2">
              <el-input v-model="formData.name" placeholder="请输入单位名称" style="width: 90%" />
            </el-form-item>
            <el-form-item label="统一社会信用代码" prop="zhengjian_number" :style="{ width: platform == 'web' ? '45%' : '100%' }" v-if="select == 2">
              <el-input v-model="formData.zhengjian_number" placeholder="请输入统一社会信用代码" style="width: 90%" />
            </el-form-item>
            <el-form-item label="手机号" prop="mobile" :style="{ width: platform == 'web' ? '45%' : '100%' }">
              <el-input v-model="formData.mobile" maxlength="11" placeholder="请输入手机号" style="width: 90%" />
            </el-form-item>
            <el-form-item label="邮箱" prop="email" :style="{ width: platform == 'web' ? '45%' : '100%' }">
              <el-input v-model="formData.email" placeholder="请输入邮箱地址" style="width: 90%" />
            </el-form-item>
          </el-form>
          <div class="custom-btn-group" v-if="status == 2">
            <el-button class="btn" @click="handleApply">申领</el-button>
          </div>
        </div>
        <div class="article pt38" v-if="current == 4">
          <div class="tabs">
            <div class="tabs-item" :class="{ current: active == 1 }" @click="tabs(1)">单笔申请</div>
            <div class="tabs-item" :class="{ current: active == 2 }" @click="tabs(2)">批量申请</div>
          </div>
          <el-form ref="formRef"  class="form" :model="form" :rules="rules" label-width="auto" label-position="top" hide-required-asterisk>
            <el-form-item prop="name">
              <el-input v-model="form.name" placeholder="请输入申领人姓名" />
            </el-form-item>
            <el-form-item label="交易单号查询(微信、支付宝、或银行交易单号)" prop="flow_number" v-if="active == 1">
              <el-input v-model="form.flow_number" placeholder="请输入微信、支付宝、或银行交易单号" />
            </el-form-item>
            <el-form-item prop="excel_url" v-if="active == 2">
              <el-input v-model="form.excel_url" clearable readonly placeholder="请选择文件">
                <template slot="append">
                  <el-upload
                    v-model="fileList"
                    class="upload-demo"
                    :action="uploadUrl"
                    :limit="1"
                    :show-file-list="false"
                    :headers="{ token }"
                    :before-upload="beforeUpload"
                    :on-success="handleSuccess"
                  >
                    <el-button class="btn">点击选择</el-button>
                  </el-upload>
                </template>
              </el-input>
            </el-form-item>
            <div v-if="active == 2 && status == 1">备注：请先下载模版，编辑后再上传文件</div>
            <el-form-item style="margin-top: 40px">
              <div class="flex-start-center">
                <el-button class="btn" v-if="status == 1" @click="handleQuery">查询</el-button>
                <!-- <el-button class="btn" v-if="active == 1 && status == 2" @click="handleApply">申领</el-button> -->
                <el-button class="btn" v-if="active == 2 && status == 1" @click="downloadTemplate" style="margin-left: 10px;">下载模板</el-button>
              </div>
            </el-form-item>
          </el-form>
          <el-table
            v-if="status == 2"
            :data="tableData"
            border
            stripe
            header-row-class-name="table-header"
            :cell-style="{ fontSize: '18px' }"
            style="width: 100%"
          >
            <el-table-column prop="pay_time_text" label="捐赠时间" align="center" />
            <el-table-column prop="price" label="捐赠金额（元）" align="center" />
            <el-table-column prop="project.title" label="项目名称" align="center" />
            <el-table-column prop="pay_type" label="支付方式" align="center" />
          </el-table>
          <div class="custom-btn-group" v-if="status == 2">
            <el-button class="btn" @click="handleApply">申领</el-button>
          </div>
          <h3 class="h3">证书申领须知</h3>
          <div class="box">
            <div class="p" v-html="config.zsslxz" style="width: 100%;"></div>
          </div>
        </div>
        <div class="article" v-if="current == 5">
          <div class="list">
            <div class="list-row" v-for="(item, index) in list" :key="index">
              <div class="title" @click="gotoDetail(item)">{{ item.title }}</div>
              <div class="time">{{ item.show_time?.slice(0, 10) }}</div>
            </div>
          </div>
        </div>
        <div class="article" v-if="current == 6">
          <div class="list">
            <div class="list-row" v-for="(item, index) in list" :key="index">
              <div class="title" @click="gotoDetail(item)">{{ item.title }}</div>
              <div class="time">{{ item.show_time?.slice(0, 10) }}</div>
            </div>
          </div>
        </div>
        <div class="pagination" v-if="current == 2 || current == 5 || current == 6">
          <el-pagination ref="pagination" layout="slot" :total="total" :current-page="page" hide-on-single-page>
            <div style="display: flex;justify-content: center;">
              <el-button type="text" class="custom-btn" :disabled="page <= 1" @click="handlePrevChange">
                <i class="el-icon-arrow-left"></i>
                上一页
              </el-button>
              <el-pagination
                layout="pager"
                :current-page="page"
                :pager-count="11"
                @current-change="handleCurrentChange"
                :page-size="10"
                :total="total">
              </el-pagination>
              <el-button type="text" class="custom-btn" :disabled="page >= lastPage" @click="handleNextChange">
                下一页
                <i class="el-icon-arrow-right"></i>
              </el-button>
            </div>
          </el-pagination>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import CifuAPI from "@/utils/api";
import { baseURL } from "@/utils/http";
import { mapState } from "vuex";
import PCNavbar from "@/components/navbar/index";
import CarouselHome from "@/components/carousel_home/index";
import Footer from "@/components/footer/index";

export default {
  name: "Donate",
  components: { PCNavbar, CarouselHome, Footer },
  data() {
    return {
      isSearch: true,
      current: 0,
      list: [],
      list2: [],
      tableData: [],
      page: 1,
      lastPage: 1,
      total: 0,
      active: 1,
      status: 1,
      select: 1,
      listrow: 0,
      aixin_status: 1,
      form: {
        name: "",
        phone: "",
        type: "1",
        flow_number: "",
        excel_url: "",
      },
      rules: {
        flow_number: [{ required: true, message: "请输入微信、支付宝、或银行交易单号", trigger: "blur" }],
        name: [{ required: true, message: "请输入申领人姓名", trigger: "blur" }],
        excel_url: [{ required: true, message: "请上传附件", trigger: "blur"  }]
      },
      fileList: [],
      uploadUrl: `${baseURL}/api/common/upload`,
      formData: {
        name: "", // 姓名 / 单位名称
        mobile: "", // 手机号
        email: "", // 邮箱
        zhengjian_number: "", // 身份证号 / 统一社会信用代码
      },
      formDataRules: {
        name: [
          {
            required: true,
            validator: (rule, value, callback) => {
              const isCompany = this.select === 2;
              if (!value) {
                callback(new Error(isCompany ? "请输入单位名称" : "请输入姓名"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { pattern: /^1[3-9]\d{9}$/, message: "手机号格式不正确", trigger: "blur" },
        ],
        email: [
          { required: false, message: "请输入邮箱地址", trigger: "blur" },
          { type: "email", message: "邮箱格式不正确", trigger: ["blur", "change"] },
        ],
        zhengjian_number: [
          {
            required: true,
            validator: (rule, value, callback) => {
              const isCompany = this.select === 2;
              const idCardReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
              const creditCodeReg = /^[0-9A-Za-z]{18}$/;

              if (!value) {
                callback(new Error(isCompany ? "请输入统一社会信用代码" : "请输入身份证号"));
                return;
              }

              if (isCompany && !creditCodeReg.test(value)) {
                callback(new Error("统一社会信用代码格式不正确"));
              } else if (!isCompany && !idCardReg.test(value)) {
                callback(new Error("身份证号格式不正确"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
    };
  },
  beforeRouteLeave(to, from, next) {
    // 保存当前滚动位置
    this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    // 也可以保存到 sessionStorage，以便刷新后也能恢复
    sessionStorage.setItem('donateScrollPosition', this.scrollPosition);
    next();
  },
  computed: {
    ...mapState(["config", "token", "platform"]),
    totalAmount() {
      return this.tableData.reduce((total, item) => {
        // 确保 price 是数字类型再累加
        const price = parseFloat(item.price);
        return isNaN(price) ? total : total + price;
      }, 0);
    },
  },
  watch: {
    select: {
      handler(newVal, oldVal) {
        this.$refs.formDataRef.clearValidate();
        if (oldVal == 1) {
          if (newVal == 2) {
            this.formData.name = "";
            this.formData.zhengjian_number = "";
          }
          if (newVal == 3) {
            this.formData.name = "爱心人士";
          }
        } else if (oldVal == 2) {
          if (newVal == 3) {
            this.formData.name = "爱心人士";
          } else {
            this.formData.name = "";
            this.formData.zhengjian_number = "";
          }
        } else if (oldVal == 3) {
          if (newVal == 1) {
            this.formData.name = "";
          }
          if (newVal == 2) {
            this.formData.name = "";
            this.formData.zhengjian_number = "";
          }
        }
      },
    },
  },
  async created() {
    await this.getConfig()
    await this.getList();
    await this.getList2();
    this.$watch(
      "$route",
      (to) => {
        const index = to.params.id || 1;
        this.toggle(index);
      },
      { immediate: true }
    );
  },
  methods: {
    async getConfig() {
      let res = await CifuAPI.getConfig()
      if (res.code == 1) {
        this.aixin_status = res.data.aixin_status
      }
    },
    toggle(index) {
      this.list = []
      this.current = index;
      if (index == 1) {
        this.getList();
        this.getList2();
      } else if (index == 2) {
        this.getList3(0);
      } else if (index == 3) {
        const number = this.$route.query.flow_number || "";
        this.form = {
          name: "",
          flow_number: number,
          excel_url: "",
        };
        if (number !== "") {
          this.handleQuery();
        }
      } else if (index == 4) {
        const number = this.$route.query.flow_number || "";
        this.form = {
          name: "",
          flow_number: number,
          excel_url: "",
        };
        // if (number !== "") {
        //   this.handleQuery();
        // }
      } else if (index == 5) {
        this.getList4("dikoushuoming");
      } else if (index == 6) {
        this.getList4("aixinchuandi");
      }
      // 更新store状态
      this.$store.dispatch("setMenuActive", `/donate?type=${index}`);
      // 更新路由参数
      this.$router.push({
        path: `/donate/${index}`
      });
    },
    tabs(index) {
      this.active = index;
      this.status = 1;
    },
    choose(index) {
      this.select = index;
    },
    async getList() {
      let res = await CifuAPI.getProjectList({ is_zaixian: 1 });
      this.list = res.data.data;
      this.listrow = this.list.length % 3
    },
    async getList2() {
      let res = await CifuAPI.getFundraisingPlatform();
      console.log(res)
      this.list2 = res.data.data;
      this.$nextTick(() => {
      const savedPosition = sessionStorage.getItem('donateScrollPosition');
        if (savedPosition) {
          const scrollTop = parseInt(savedPosition, 10);
          // 延迟一下确保页面完全渲染
          setTimeout(() => {
            window.scrollTo(0, scrollTop);
            document.documentElement.scrollTop = scrollTop;
            document.body.scrollTop = scrollTop;
          }, 100);
        }
      });
    },
    async getList3(type) {
      let res = await CifuAPI.getDonateList({ is_mylog: type, page: this.page });
      if (res.code == 1) {
        this.tableData = res.data.data;
        this.lastPage = res.data.last_page;
        this.total = res.data.total;
        this.isSearch = type == 1 && res.data.total == 0 ? false : true;
      }
    },
    async getList4(type) {
      const res = await CifuAPI.getArticleList({ model_type: type });
      if (res.code == 1) {
        this.list = res.data.data;
        this.lastPage = res.data.last_page;
        this.total = res.data.total;
      }
    },
    handleToProjectDetail(id) {
      this.$router.push(`/projectDetail?type=1&id=${id}`);
    },
    handlePrevChange() {
      const index = this.current;
      this.page--;
      this.toggle(index);
    },
    handleCurrentChange(e) {
      const index = this.current;
      this.page = e;
      this.toggle(index);
    },
    handleNextChange() {
      const index = this.current;
      this.page++;
      this.toggle(index);
    },
    queryMyData() {
      this.page = 1;
      this.getList3(1);
    },
    gotoDetail(item) {
      console.log(this.active);

      this.$router.push(`/donateDetail?type=${this.current}&id=${item.id}`);
    },
    async handleQuery() {
      const { flow_number, excel_url, name } = this.form;
      const params = {};
      if (this.active == 1) {
        params.flow_number = flow_number;
        params.name = name
      } else {
        params.excel_url = excel_url;
        params.name = name
      }
      if (this.active == 1) {
        if (!params.name) {
          this.$message.warning('请输入申领人姓名')
          return false
        }
        if (!params.flow_number) {
          this.$message.warning('请输入交易单号')
          return false
        }
        const res = await CifuAPI.getDonateList(params);
        if (res.code == 1) {
          this.status = 2;
          this.tableData = res.data.data;
        }
      } else {
        console.log(params.name)
        if (!params.name) {
          this.$message.warning('请输入申领人姓名')
          return false
        }
        if (!params.excel_url) {
          this.$message.warning('请选择文件')
          return false
        }
        const res = await CifuAPI.getDonateList(params);
        if (res.code == 1) {
          this.status = 2;
          this.tableData = res.data.data;
        }
      }
    },
    async handleApply() {
      if (this.current == 3) {
        this.$refs.formDataRef.validate(async (valid) => {
          if (valid) {
            const data = JSON.parse(JSON.stringify(this.formData));
            data.type = this.select;
            if (this.select !== 2) {
              data.zhengjian_type = 1;
            }
            if (this.active == 1) {
              data.flow_number = this.form.flow_number;
              const res = await CifuAPI.applyBill(data);
              if (res.code == 1) {
                this.$message.success("申请成功");
              }
            } else {
              data.excel_url = this.form.excel_url;
              const res = await CifuAPI.batachApplyBill(data);
              if (res.code == 1) {
                this.$message.success("申请成功");
              }
            }
          }
        });
      } else {
        const { excel_url, flow_number } = JSON.parse(JSON.stringify(this.form));
        const data = {};
        if (this.active == 1) {
          data.flow_number = flow_number;
          const res = await CifuAPI.applyCert(data);
          if (res.code == 1) {
            this.$message.success("申请成功");
          }
        } else {
          data.excel_url = excel_url;
          const res = await CifuAPI.batchApplyCert(data);
          if (res.code == 1) {
            this.$message.success("申请成功");
          }
        }
      }
    },
    //获取文件名称
    getFileNameFromURL(url) {
      const urlParts = url.split("/");
      return decodeURIComponent(urlParts[urlParts.length - 1]);
    },
    async downloadTemplate() {
      try {
        const res = await CifuAPI.downloadTemplate();
        if (res.code === 1 && res.data) {
          const fileUrl = res.data; // 获取文件地址
          const a = document.createElement("a");
          const fileName = this.getFileNameFromURL(res.data);
          a.href = fileUrl;
          a.download = fileName; // 可留空由浏览器决定文件名，或手动设置
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        } else {
          this.$message.error("文件下载失败");
        }
      } catch (error) {
        console.error("下载异常:", error);
        this.$message.error("下载过程中发生错误");
      }
    },

    // 通用上传成功处理
    beforeUpload(file) {
      const excelTypes = ["application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"];
      const fileExt = file.name.split(".").pop().toLowerCase();
      const isValidSize = file.size / 1024 / 1024 < 30;

      if (!excelTypes.includes(file.type) && !["xls", "xlsx"].includes(fileExt)) {
        this.$message.error("请上传 .xls 或 .xlsx 格式的Excel文件");
        return false;
      }

      if (!isValidSize) {
        this.$message.error("文件大小不能超过 30MB!");
        return false;
      }

      return true;
    },
    // 通用上传成功处理
    handleSuccess(res) {
      if (res.code == 1) {
        this.form.excel_url = res.data.url; // 赋值照片路径
        this.form.excel_url2 = res.data.fullurl; // 赋值照片路径
      } else {
        this.$message.error("上传失败，请重试");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pageView{
  width: 100%;
  min-width: 1400px;
}
.main-wrap {
  width: 100%;
  min-width: 1400px;
  @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
    padding: 0 20px;
  }
}
.tab {
  margin-top: 0;
  overflow-x: auto;
}
.article {
  &.pt38 {
    padding-top: 38px;
    @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
      padding-top: 20px;
    }
  }
  .h3 {
    padding-top: 10px;
    font-size: 28px;
    color: #663301;
    @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
      padding-top: 0;
      font-size: 16px;
    }
  }
  .p {
    font-size: 18px;
    color: #4f4f4f;
    line-height: 32px;
    @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
      line-height: 22px;
      font-size: 16px;
      ::v-deep span{
        font-size: 16px !important;
      }
    }
  }
  .info {
    display: flex;
    gap: 50px;
    padding-top: 50px;
    padding-bottom: 67px;
    @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
      flex-direction: column;
      padding-top: 20px;
      padding-bottom: 20px;
      gap: 20px;
    }
    .msg {
      display: flex;
      width: 50%;
      @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
        width: 100%;
      }
      .left {
        width: 60px;
        .title {
          width: 110px;
          padding: 10px 0;
          color: rgba(251, 206, 0, 0.4);
          font-size: 26px;
          white-space: nowrap;
          transform: rotate(-90deg) translateX(12px); /* 实现反向效果 */
          transform-origin: bottom;
        }
        .num {
          margin-top: 152px;
          line-height: 64px;
          font-weight: 900;
          font-size: 79px;
          color: #fbce00;
        }
      }
      .right {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: calc(100% - 60px);
        height: 277px;
        padding: 34px 46px;
        background: rgba(251, 206, 0, 0.1);
        border-left: 2px solid #fbce00;
        // @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
        //   padding: 20px;
        // }
        .row {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          // @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
          //   flex-direction: column;
          // }
          .label {
            width: 86px;
            padding-right: 26px;
            font-weight: bold;
            font-size: 16px;
            color: #663301;
            text-align: justify;
            text-align-last: justify;
            // @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
            //   width: 100%;
            //   padding: 0;
            //   text-align: left;
            //   text-align-last: left;
            //   font-size: 16px;
            // }
          }
          .text {
            flex: 1;
            white-space: nowrap;
            font-size: 16px;
            padding: 5px 0px;
            color: #828282;
            // @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
            //   width: 100%;
            //   padding-top: 10px;
            //   font-size: 12px;
            // }
          }
        }
      }
    }
  }
  .box {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
    gap: 30px;
    padding: 50px 0;
    @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
      padding: 20px 0;
      gap: 10px;
    }
    &-item {
      width: 530px;
      padding: 10px;
      border: 2px solid #f2f2f2;
      text-align: center;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover {
        border-color: #fbce00;
        .box-inner {
          background: #fbce00;
        }
      }
      @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
        flex: 1 0 100%;
        padding: 10px;
      }
    }
    &-item1 {
      flex: 1 0 calc(33.33% - 34px);
      padding: 14px;
      cursor: pointer;
      &:hover {
        border-color: #fbce00;
        .box-inner {
          background: #fbce00;
        }
      }
      @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
        flex: 1 0 100%;
        padding: 10px;
      }
    }
    &-inner {
      padding: 18px 28px;
      height: 100%;
      width: 100%;
      background: #f2f2f2;
      display: flex;
      align-items: center;
      justify-content: center;
      @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
        padding: 10px;
        font-size: 14px;
      }
      .fontStyle{
        width: 410px;
        font-weight: bold;
        font-size: 28px;
        color: #663301;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .jigou {
    .img {
      width: 228px;
      height: 140px;
      background: #d9d9d9;
      border-radius: 0px 0px 0px 0px;
    }
    .h4 {
      width: 228px;
      height: 23px;
      font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
      font-weight: 500;
      font-size: 20px;
      color: #4f4f4f;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }
  }
  .search {
    &-block {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 120px;
      padding: 34px 46px;
      margin-bottom: 50px;
      background: #fffae5;
      border-left: 8px solid #fbce00;
      @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
        padding: 20px 20px;
        height: auto;
        margin-bottom: 20px;
      }
    }
    &-text {
      font-weight: bold;
      font-size: 28px;
      color: #663301;
      @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
        font-size: 12px;
      }
    }
    &-btn {
      width: 148px;
      height: 53px;
      background: #663301;
      border-color: #663301;
      font-size: 18px;
      color: #fff;
      border-radius: 64px;
      @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
        width: 100px;
        height: 40px;
        padding: 0;
        font-size: 12px;
      }
    }
  }
  .tabs {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e0e0e0;
    &-item {
      height: 84px;
      line-height: 80px;
      border-bottom: 4px solid transparent;
      margin-right: 70px;
      font-size: 28px;
      color: #4f4f4f;
      cursor: pointer;
      @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
        height: 40px;
        line-height: 40px;
        margin-right: 40px;
        font-size: 14px;
      }
      &.current {
        color: #663301;
        border-bottom-color: #663301;
      }
    }
  }
  .form {
    width: 782px;
    @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
      width: 100%;
    }
    .upload-demo {
      padding-left: 0;
    }
  }
  .list-row {
    width: 100%;
  }
}
.table-header {
  background: rgba(251, 206, 0, 0.2);
}
.custom-btn-group {
  padding-top: 30px;
  text-align: center;
  @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
    padding-top: 10px;
  }
}
.totalInfo {
  padding-bottom: 20px;
  font-size: 18px;
  color: #663301;
  @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
    font-size: 12px;
  }
  .ite {
    margin-right: 30px;
    @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
      margin-right: 16px;
    }
  }
}
::v-deep .el-input-group__append {
  margin: 0 !important;
}
::v-deep .el-button--default{
  padding-top: 8px;
  padding-bottom: 8px;
}
::v-deep .downBtn{
  margin-left: 10px !important;
}
::v-deep .el-pager{
  li{
    background: #f5f5f5 !important;
    font-size: 18px;
    color: #999;
  }
  .active{
    color: #663301;
  }
}
</style>
